import React from 'react'
import { StyleSheet, View, Image } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { backgroundColors, colors, typography } from '@sart/styles'
import { useContent } from '@sart/content'
import {
  Title,
  Description,
  Space
} from '@sart/components'

export default function Community(props) {
    const content = useContent()

    return (
        <SafeAreaView backgroundColor={backgroundColors.darkCharcoal}>
            <View>
                <Space height={25} />
                <View style={styles.logo}>
                    <Image
                        source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
                        height={100} width={100}
                    />
                </View>
                <Space height={25} />
                <Title style={styles.title}>{content.community.title}</Title>
                <Space height={25} />
                <Description style={styles.description}>
                    {content.community.movement}
                </Description>
                <Space height={25} />
                <Description style={styles.description}>
                    {content.community.vision}
                </Description>
                <Space height={25} />
                <Description style={styles.description}>
                    {content.community.reinvest}
                </Description>
                <Space height={25} />
                <Description style={styles.description}>
                    {content.community.comingSoon}
                </Description>
            </View>
        </SafeAreaView>
    )

}

const styles = StyleSheet.create({
  logo: {
    alignSelf: 'center'
  },
  title: {
    color: colors.brightOrange,
    ...typography.demi,
    marginLeft: 30,
    marginRight: 30
  },
  description: {
    textAlign: 'center',
    color: colors.white,
    ...typography.demi,
    marginLeft: 30,
    marginRight: 30
  }
})
